import { render, staticRenderFns } from "./IFooter.vue?vue&type=template&id=5722563b&scoped=true&"
import script from "./IFooter.vue?vue&type=script&lang=js&"
export * from "./IFooter.vue?vue&type=script&lang=js&"
import style0 from "./IFooter.vue?vue&type=style&index=0&id=5722563b&prod&lang=stylus&rel=stylesheet%2Fstylus&scoped=true&"
import style1 from "./IFooter.vue?vue&type=style&index=1&id=5722563b&prod&lang=stylus&rel=stylesheet%2Fstylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5722563b",
  null
  
)

export default component.exports